import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const MuiLoadingSpinner = () => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', py: 6 }}>
      <CircularProgress />
    </Box>
  )
}

export default MuiLoadingSpinner